import { render, staticRenderFns } from "./OrderAddressSection.vue?vue&type=template&id=36767cd6&"
import script from "./OrderAddressSection.vue?vue&type=script&lang=js&"
export * from "./OrderAddressSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports